import ContactForm from "./contactForm"

const Contact = ()=>{
    return(
        <div className="bg-red-600 min-w-screen min-h-screen flex flex-col justify-center items-center py-2">
            <ContactForm />
        </div>
    )
}
export default Contact